import Locale from 'bee-locale'

export default Locale
